<template>
  <right-menu-item
    @click.prevent="click"
    :class="{'!text-red-600': !loading && isActive, 'muted': !isActive}"
    :text="$t('Edit')"
    :loading="loading"
    icon="pen"
    icon-class=""
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import EditFile from '../../mixins/actions/EditFile'

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    isActive () {
      return this.bcSelectedStore.listSelected.length === 1
    },
    ...mapStores(useBcSelectedStore),
  },
  methods: {
    async click() {
      this.loading = true
      await EditFile(this.$store, this.$formValues, this.bcSelectedStore.listSelected[0].id)
      this.loading = false
    }
  },
}
</script>

<style lang="scss" scoped></style>
